// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3Nccc","errorLogs":"EditorFooter_errorLogs__3_SwK"};